module.exports = __webpack_public_path__ + "static/media/ease-of-use.6e8e971b.png";